import { create } from 'zustand';

interface AccountCollapseState {
  shouldCollapseAll: boolean;
  collapseAllAccounts: () => void;
  resetCollapseState: () => void;
}

export const useAccountCollapseStore = create<AccountCollapseState>((set) => ({
  shouldCollapseAll: false,
  collapseAllAccounts: () => set({ shouldCollapseAll: true }),
  resetCollapseState: () => set({ shouldCollapseAll: false }),
})); 